// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3cCc-","title":"Images45_title__3t2_y","images":"Images45_images__2uLAW"};